import React from 'react';
import { Card, Badge } from './ui';
import { CheckCircle, Book, BookOpen, BookMarked, Library, Notebook, BookType, Gift, Footprints } from 'lucide-react';
export function Product() {
  const tomos = [{
    icon: <Book className="w-8 h-8 text-blue-400" data-id="element-92" data-mp="28cvha1mt5b7e" />,
    color: 'bg-blue-500/10 border-blue-500/20',
    title: 'TOMO 1 — El Despegue Mental y Físico',
    subtitle: 'Prepará tu cuerpo y tu mente antes de empezar',
    desc: 'Cómo construir la base que necesitás para dejar de postergar y empezar a correr con confianza.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-brand-400" data-id="element-93" data-mp="2r1jyaci66wdw" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 2 — Tu Primer Kilómetro',
    subtitle: 'Técnica, respiración, postura y ritmo',
    desc: 'Aprendé a correr sin agotarte entendiendo qué hacer con tu respiración, tu cuerpo y tu velocidad.'
  }, {
    icon: <BookMarked className="w-8 h-8 text-blue-400" data-id="element-94" data-mp="2w27myrixf14y" />,
    color: 'bg-blue-500/10 border-blue-500/20',
    title: 'TOMO 3 — Nutrición y Combustible Low-Cost',
    subtitle: 'Comé bien sin gastar una fortuna',
    desc: 'Qué comer antes y después de entrenar para rendir mejor sin complicarte ni comprar de más.'
  }, {
    icon: <Library className="w-8 h-8 text-brand-400" data-id="element-95" data-mp="25kpsbbeshxzh" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 4 — El Escudo Anti-Lesiones',
    subtitle: 'Protegé rodillas, tobillos y espalda',
    desc: 'Fortalecimiento y movilidad simples para que puedas avanzar con más seguridad desde el comienzo.'
  }, {
    icon: <Notebook className="w-8 h-8 text-blue-400" data-id="element-96" data-mp="2o8kzudjt6fk5" />,
    color: 'bg-blue-500/10 border-blue-500/20',
    title: 'TOMO 5 — La Ruta hacia los 5K',
    subtitle: 'Tu plan progresivo de 8 semanas',
    desc: 'SeguÍ una progresión clara para llegar preparado a tus primeros cinco kilómetros, sin improvisar.'
  }, {
    icon: <BookType className="w-8 h-8 text-brand-400" data-id="element-97" data-mp="3295f4zqilt8w" />,
    color: 'bg-brand-500/10 border-brand-500/20',
    title: 'TOMO 6 — El Día de la Carrera y el Post',
    subtitle: 'Cruzá tu primera meta y seguí progresando',
    desc: 'Cómo correr tu primera carrera, recuperarte correctamente y disfrutar lo que sigue después de los 5K.'
  }];
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-98" data-mp="174xswabyae7r">
      <div className="max-w-5xl mx-auto" data-id="element-99" data-mp="1luc0pdzvonl1">
        <div className="text-center mb-10" data-id="element-100" data-mp="1ltaqfbqos54d">
          <Badge variant="success" className="mb-4" data-id="element-101" data-mp="1lw6lmsb5gfp4">RUNNING DESDE CERO™ — MEGAPACK COMPLETO</Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-102" data-mp="1gxlk8pk5vpz3">
            Todo lo que necesitás para llegar a tus primeros 5 kilómetros.
          </h2>
          <p className="text-xl text-slate-400" data-id="element-103" data-mp="1px8mteomn1tq">
            Un sistema completo pensado para personas que empiezan desde cero y quieren aprender a correr correctamente, evitando lesiones y disfrutando del proceso.
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-6 text-sm font-medium text-brand-400" data-id="element-104" data-mp="3rpes8myyn2zh">
            <span data-id="element-105" data-mp="277m09cl9t0yu">Sin ahogarte</span><span className="text-slate-600" data-id="element-106" data-mp="2c42wku2miln0">→</span><span data-id="element-107" data-mp="2c31ew6r3r0wb">Sin lesionarte</span><span className="text-slate-600" data-id="element-108" data-mp="2c6gqgzlkhrsz">→</span><span data-id="element-109" data-mp="1ydhfnawqclrr">Con un plan claro</span><span className="text-slate-600" data-id="element-110" data-mp="1yc6bh9zdhc04">→</span><span data-id="element-111" data-mp="1yb4w4tbbq3cl">Hasta los 5K</span>
          </div>
        </div>

        <div className="mb-10" data-id="element-112" data-mp="22d0065kn2uu2">
          <h3 className="text-xl font-bold text-white mb-5 flex items-center gap-3" data-id="element-113" data-mp="22c6rv0617x9t">
            <Footprints className="w-8 h-8 text-brand-400" data-id="element-114" data-mp="1oguvkoc89yqs" /> Cada etapa tiene una solución específica
          </h3>
          <p className="text-slate-400 text-sm leading-relaxed mb-5" data-id="element-115" data-mp="1fe3h0fo22mux">
            No todas las personas empiezan con el mismo obstáculo: algunas se quedan sin aire, otras sienten miedo de lesionarse o no saben cómo armar una rutina. Por eso el Megapack está dividido en seis etapas, cada una diseñada para acercarte a tu primera meta.
          </p>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-116" data-mp="3dsevz6143gnl">
            {tomos.map((tomo, i) => <Card key={i} className={`border ${tomo.color}`} data-id="element-117" data-mp="2p20p94lkqn0m" data-mpi={i}>
                <div className="flex items-start gap-4" data-id="element-118" data-mp="2k48qprqfc2ng">
                  <div className="p-3 bg-slate-900 rounded-xl shrink-0" data-id="element-119" data-mp="2k4qt763ojd3t">{tomo.icon}</div>
                  <div data-id="element-120" data-mp="2f3bahkoz5iol">
                    <h4 className="font-bold text-white text-lg mb-1" data-id="element-121" data-mp="2f6pcgrtq7pvi">{tomo.title}</h4>
                    <p className="text-brand-400 text-sm font-medium mb-3" data-id="element-122" data-mp="2a5jf2gp4fefn">{tomo.subtitle}</p>
                    <p className="text-slate-400 text-sm leading-relaxed" data-id="element-123" data-mp="265is27nyhuwz">{tomo.desc}</p>
                  </div>
                </div>
              </Card>)}
          </div>
        </div>

        <Card className="bg-slate-900" data-id="element-124" data-mp="1weo5f26sstb0">
          <h4 className="font-bold text-xl text-white mb-6" data-id="element-125" data-mp="1rfjwmcnscxl7">En cada etapa encontrás:</h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-126" data-mp="1mg7axv8nhwk7">
            {['Pasos claros para empezar incluso si hoy no corrés nada', 'Rutinas progresivas para mejorar sin agotarte', 'Técnica simple para cuidar tu cuerpo desde el primer día', 'Herramientas para sostener la motivación semana a semana', 'Criterios para elegir equipamiento sin gastar de más', 'Alternativas para adaptar el plan a tu punto de partida', 'Recursos listos para aplicar en tu próximo entrenamiento', 'Una ruta realista para llegar a tus primeros 5K'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-127" data-mp="3afswcvz2x11n" data-mpi={i}>
                <CheckCircle className="w-5 h-5 text-brand-400 shrink-0 mt-0.5" data-id="element-128" data-mp="3fcawfijgsb7n" />
                <span className="text-slate-300" data-id="element-129" data-mp="3kbnlm9xt5ude">{item}</span>
              </div>)}
          </div>
        </Card>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    title: 'Guía de Rutas y Seguridad',
    desc: 'Elegí mejores lugares para entrenar y corré con consejos concretos de seguridad.',
    value: '$8.000'
  }, {
    title: 'Playlist y Ritmo de Zancada (BPM)',
    desc: 'Usá la música para encontrar un ritmo más cómodo y sostener tu resistencia.',
    value: '$8.000'
  }, {
    title: 'Diario de Entrenamiento',
    desc: 'Registrá tus avances, organizá tus sesiones y mantené viva la motivación.',
    value: '$9.000'
  }, {
    title: 'Running y Descenso de Peso',
    desc: 'Combiná el running con una alimentación inteligente para quemar grasa de forma sostenible.',
    value: '$8.000'
  }, {
    title: 'Prevención de Lesiones',
    desc: 'Guía rápida para actuar ante ampollas, sobrecargas y molestias comunes.',
    value: '$9.000'
  }];
  return <section className="py-12 px-4" data-id="element-130" data-mp="21nsesonk8tg1">
      <div className="max-w-5xl mx-auto" data-id="element-131" data-mp="2flqhuxwfl3g8">
        <div className="text-center mb-8" data-id="element-132" data-mp="2fmibi36gwr3v">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 flex items-center justify-center gap-3" data-id="element-133" data-mp="2amdwkhl7k4fr">
            <Gift className="w-9 h-9 text-brand-400" data-id="element-134" data-mp="3qzktn2o7toq5" />5 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-brand-400 font-bold uppercase tracking-widest" data-id="element-135" data-mp="3m1sov82h284j">Siempre incluidos</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-4 mb-8" data-id="element-136" data-mp="17sgpgtvuhchb">
          {bonuses.map((bono, i) => <Card key={i} className={`relative overflow-hidden group hover:border-brand-500/50 transition-colors lg:col-span-2 ${i === 3 ? 'lg:col-start-2' : ''}`} data-id="element-137" data-mp="1cte63217hygp" data-mpi={i}>
              <div className="absolute top-0 right-0 bg-brand-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-138" data-mp="13repuby0myet">BONO {i + 1}</div>
              <h4 className="font-bold text-white text-lg mb-3 pr-12 mt-2" data-id="element-139" data-mp="1ri0xw380siot">{bono.title}</h4>
              <p className="text-slate-400 text-sm mb-6" data-id="element-140" data-mp="1vhsyntr69kjm">{bono.desc}</p>
              <div className="mt-auto pt-4 border-t border-slate-800 flex justify-between items-center" data-id="element-141" data-mp="1hs7iss8o5lft">
                <span className="line-through text-slate-500 text-sm" data-id="element-142" data-mp="1mpzbhoh51bl2">Valor {bono.value}</span>
                <span className="text-brand-400 font-bold" data-id="element-143" data-mp="2ag3epuqez9bj">GRATIS</span>
              </div>
            </Card>)}
        </div>

        <div className="bg-slate-900 border border-brand-500/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-144" data-mp="2f8mvt1ob8ml3">
          <p className="text-slate-300 mb-2" data-id="element-145" data-mp="f6x08krtgqbf">Valor total bonos</p>
          <p className="text-4xl font-black text-white mb-2 line-through decoration-red-500/50" data-id="element-146" data-mp="ad2hpkny6hdx">$51.000</p>
          <p className="text-2xl font-bold text-brand-400" data-id="element-147" data-mp="5fsnlrpm5hjr">→ GRATIS con tu Megapack completo</p>
        </div>
      </div>
    </section>;
}